export const config: any = {
  public_url: process.env.REACT_APP_PUBLIC_URL,
  fbAppId: process.env.REACT_APP_FB_APP_ID,
  // api
  api: {
    isExpired: 401,
    url: process.env.REACT_APP_API_URL,
    cloudImgPath: process.env.REACT_APP_S3_URL,
  },
  mapApiKey: "AIzaSyCg9HsL2VpDd6RSRQINPZrG5mSj_KdjfBg",
  cryptKey: "ABCD",
  paginationOptions: [
    { label: "10 Rows", value: 10 },
    { label: "25 Rows", value: 25 },
    { label: "50 Rows", value: 50 },
    { label: "100 Rows", value: 100 },
  ],
  // elements
  elements: {
    dp: "MMMM DD, YYYY",
    singleDp: {
      singleDatePicker: true,
      showDropdowns: true,
      locale: {
        format: "MMMM DD, YYYY",
      },
      autoApply: true,
      autoUpdateInput: false,
      isClearable: true,
    },
    toast: {
      ToastPosition: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    },
    modalStyle: {
      maxWidth: "450px",
      margin: "0 auto",
      Position: "absolute",
      top: "10%",
      left: "50%",
      transform: "translateX(-50%)",
    }
  },
  options: {
    roles: [
      { value: "super", label: "Super Admin", disabled: false },
      { value: "admin", label: "Admin", disabled: false },
      { value: "basic_user", label: "Basic User", disabled: false },
      { value: "premium_free", label: "Premium Free", disabled: false },
    ],
    accessNames: [
      { value: "r", label: "Read" },
      { value: "a", label: "Add" },
      { value: "u", label: "Update" },
      { value: "d", label: "Delete" },
      { value: "i", label: "Import" },
      { value: "e", label: "Export" },
    ],
    pages: [
      { label: "10 Rows", value: 10 },
      { label: "25 Rows", value: 25 },
      { label: "50 Rows", value: 50 },
      { label: "100 Rows", value: 100 },
    ],
    boolean: [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ]
  }
};
